<template>
  <div class="brands-container">
    <div class="brands-title">
      <h1>NOS MARQUES</h1>
    
    </div>
      <div class="breadcrumb">
        <a href="/">Accueil</a> > <RouterLink to="/marques">Marques</RouterLink>
      </div>
    <div class="supracare-description">
      <link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&family=Open+Sans:wght@300;400;600&display=swap" rel="stylesheet">
   <div class="content twocolums clearfix">
    <div id="c255" class="frame frame-default frame-type-textmedia frame-layout-0">
          <a id="c849"></a>
      <h2>Marques de confiance</h2>
      <p>
        Supracare travaille en partenariat avec des marques reconnues mondialement pour fournir les produits les plus fiables et de la meilleure qualité.
      </p>

      <h2>Nos Partenaires</h2>
      <p>
        Nous collaborons avec des entreprises leaders dans l'industrie, garantissant ainsi la fiabilité des produits proposés.
      </p>
      </div>
    </div>
    </div>
     <div id="c256" class="frame frame-default frame-type-list frame-layout-0">
          <a id="c850"></a>
          <div class="referenzenOuterWrapper clearfix">
               <div class="referenzen-grid">
            <div class="referenzenWrapper">
              <img alt="Almirall" src="@/assets/MARQUES/accumax.png" width="180" height="51">
            </div>
            <div class="referenzenWrapper">
              <img alt="Apollinaris" src="@/assets/MARQUES/flmedical.png" width="180" height="96">
            </div>
            <div class="referenzenWrapper">
              <img alt="applichem" src="@/assets/MARQUES/headway.png" width="180" height="53">
            </div>
            <div class="referenzenWrapper">
              <img alt="BAM" src="@/assets/MARQUES/maccura.png" width="180" height="121">
            </div>
            <div class="referenzenWrapper">
              <img alt="baxter" src="@/assets/MARQUES/odak.png" width="180" height="59" style="background-color: black;">
            </div>
            <div class="referenzenWrapper">
              <img alt="Bayer" src="@/assets/MARQUES/singuway.png" width="180" height="81">
            </div>
               <div class="referenzenWrapper">
              <img alt="Bayer" src="@/assets/MARQUES/polycheck.png" width="180" height="81">
            </div>
             
          </div>
          </div>
          <div class="referenzenTextClear">&nbsp;</div>
          <div class="referenzenItemTextWrapper clearfix"></div>
        </div>
      </div>
  

</template>

<script>
export default {
  name: 'BrandsPage',
};
</script>

<style scoped>
.brands-container {
  padding: 0px 0px;
  background-color: #f9f9f9;
  text-align: justify;
  z-index: 1;
  overflow: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    margin-bottom: 500px;
}

.brands-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: -1;
}

.brands-title {
  position: relative;
   background: linear-gradient(to right,#a8f8e8, rgb(127, 121, 235),#a8f8e8);
  background-size: cover;
  background-position: center;
  color: rgb(29, 22, 77);
  padding: 10px 400px;
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
  border-radius: 2px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  z-index: 1;
}
.produits-title a:hover{
   transform: scale(1.1);
  box-shadow: 0 5px 15px rgba(246, 239, 239, 0.4);
}

.breadcrumb {
  font-size: 10px;
  color: #888;
  margin-top: 0px;
  padding: 10px 50px;

}

.breadcrumb a {
  color: #1c1c1d;
  text-decoration: none;
  transition: color 0.3s ease;
}

.breadcrumb a:hover {
  color: #0056b3; /* Couleur au survol */
}

.supracare-description {
  padding: 20px 200px;

  border-radius: 2px;
  margin-top: 0px;
  font-family: 'Open Sans', sans-serif;
}

.supracare-description h2 {
  color: #4c4a4d;
  font-size: 1.8rem;
  margin-bottom: 15px;
  font-family: 'Merriweather', serif;
}

.supracare-description p {
  font-size: 1.1rem;
  line-height: 1.75;
  color: #333;
  margin-bottom: 20px;
  font-family: 'Open Sans', sans-serif;
}
.content {
  margin-top: 30px;
}

.referenzen-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.referenzenWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8); /* Blanc semi-transparent */
  border-radius: 10px;
  padding: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}


.referenzenWrapper img {
  max-width: 100%;
  height: auto;
}

.referenzenWrapper:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}


@media (max-width: 768px) {
  .brands-title {
    font-size: 2rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
  
}


/* Responsive pour les petits écrans */
@media (max-width: 768px) {
  .brands-title {
    font-size: clamp(1.5rem, 5vw, 1rem);
    padding: 100px 0px;
  }

  .breadcrumb {
    font-size: 0.9rem;
  }

  .supracare-description {
    padding: 20px;
  }

  .supracare-description h2 {
    font-size: 1.5rem;
  }

  .supracare-description p {
    font-size: 1rem;
  }
}
</style>
